import React from 'react';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import AppTheme from '../../../components/theme/AppTheme';
import { useAutomationNotifications } from '../viewmodels/useAutomationNotifications';
export default function AutomationNotifications() {
  const [notices, holder] = notification.useNotification(), navigate = useNavigate();
  useAutomationNotifications({ show: notices.info, dismiss: notices.destroy, navigate });
  return <AppTheme>{holder}</AppTheme>;
}
